import { render, staticRenderFns } from "./DocumentRequest.vue?vue&type=template&id=3bbb9448&scoped=true&"
import script from "./DocumentRequest.vue?vue&type=script&lang=js&"
export * from "./DocumentRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbb9448",
  null
  
)

export default component.exports